import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import { formatFileSize } from '@/lib/formatters';

/** Files picked for a support message, each removable before sending. */
export function AttachmentList({
  files,
  onRemove
}: {
  files: File[];
  onRemove: (index: number) => void;
}) {
  const { t } = useTranslation();
  if (files.length === 0) return null;

  return (
    <ul className="space-y-1">
      {files.map((file, index) => (
        <li
          key={`${file.name}-${file.lastModified}`}
          className="flex items-center justify-between gap-2 rounded-md border px-3 py-2 text-sm"
        >
          <span className="truncate">{file.name}</span>
          <span className="flex items-center gap-2 shrink-0 text-muted-foreground">
            {formatFileSize(file.size)}
            <button
              type="button"
              onClick={() => onRemove(index)}
              aria-label={t('helpCenter.contact.attachmentRemove', { name: file.name })}
              className="hover:text-foreground"
            >
              <X className="h-4 w-4" />
            </button>
          </span>
        </li>
      ))}
    </ul>
  );
}
